import http from './http';
import { auth } from '../firebase';

export async function groupAnnouncementRequest(operation, data) {
    const token = await auth.currentUser?.getIdToken();
    if (!token) throw new Error('Sign in to manage group announcement emails.');
    try {
        const response = await http.post(`/api/v1/apcs/group-announcement-emails/${operation}`, data,
            { headers: { 'auth-token': token }, timeout: 90000 });
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.message || (operation === 'send'
            ? 'Campaign request was interrupted. Refresh saved progress before retrying.'
            : operation === 'resend' ? 'Resend request was interrupted. Check delivery before resending again.'
                : 'Request failed. Check test delivery before retrying.'));
    }
}
